const cities = [
  { name: "Oklahoma City", zips: "73102, 73103, 73104, 73105, 73106, 73107, 73108, 73109, 73110, 73111, 73112, 73114, 73115, 73116, 73117, 73118, 73119, 73120, 73121, 73122, 73127, 73128, 73129, 73130, 73131, 73132, 73134, 73135, 73139, 73142, 73145, 73149, 73150, 73151, 73159, 73160, 73162, 73169, 73170, 73173, 73179" },
  { name: "Midwest City", zips: "73110, 73130, 73141" },
  { name: "Moore", zips: "73160, 73165, 73170" },
  { name: "Yukon", zips: "73099" },
  { name: "Mustang", zips: "73064" },
  { name: "Bethany", zips: "73108, 73122" },
  { name: "Warr Acres", zips: "73122, 73132" },
  { name: "The Village", zips: "73120" },
];

const benefits = [
  {
    icon: "ri-computer-line",
    title: "Start 100% Online",
    desc: "No office visit required to begin. Complete your order from your home, office, or Tinker AFB in minutes.",
  },
  {
    icon: "ri-truck-line",
    title: "Ship Your Documents",
    desc: "Use overnight shipping to send your documents directly to us — we handle every detail from there.",
  },
  {
    icon: "ri-shield-check-line",
    title: "Expert Document Review",
    desc: "Every application is reviewed by our team before submission to reduce errors and prevent delays.",
  },
  {
    icon: "ri-calendar-check-line",
    title: "Reserved Agency Access",
    desc: "We hold reserved submission slots at the regional passport agency — no public appointment needed.",
  },
];

export default function OKCLocalAreaSection() {
  return (
    <section id="service-area" className="bg-white py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Service Area</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Serving Oklahoma City &amp; Central Oklahoma
          </h2>
        </div>

        <div className="max-w-4xl mx-auto mb-16">
          <div className="bg-[#F7F8FA] rounded-lg p-8 md:p-10 border border-gray-200">
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              Oklahoma City is the capital and largest city of Oklahoma, home to over 680,000 residents and the heart of the state's economic and cultural life. As the seat of Oklahoma County and the anchor of the OKC Metro area, the city serves a diverse population with unique passport needs that vary by neighborhood, profession, and lifestyle.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">Downtown &amp; Bricktown:</strong> The central business district is home to Oklahoma's energy industry headquarters, including Devon Energy, Chesapeake Energy, and numerous oil and gas firms. Business travelers from downtown OKC frequently need expedited passport renewals for international trade missions, conferences in Dubai, London, and Tokyo, and corporate retreats. The proximity to Will Rogers World Airport makes last-minute travel common — and passport emergencies frequent.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">Tinker Air Force Base &amp; Midwest City:</strong> Tinker AFB is the largest military installation in Oklahoma with over 26,000 military and civilian personnel. Military families receive PCS orders with short notice, often requiring passport renewals for dependents before OCONUS assignments. The base passport office serves active duty but has limited hours and capacity. Our expedited service helps Tinker families meet tight timelines for moves to Germany, Japan, South Korea, and the UK.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">OU Health &amp; Medical District:</strong> The Oklahoma Health Center near downtown OKC is a major biomedical research and clinical hub. Physicians, researchers, and medical staff frequently travel to international conferences in Geneva, London, and Tokyo. Our expedited service ensures medical professionals can focus on their work while we handle their passport processing.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">Midtown &amp; Paseo Arts District:</strong> These revitalized urban neighborhoods attract young professionals, creatives, and remote workers who travel internationally for leisure, work, and cultural exchange. The area's growing population of frequent travelers creates year-round demand for both routine renewals and expedited service.
            </p>
            <p className="text-gray-600 text-base leading-[1.8] mb-5">
              <strong className="text-[#1A365D]">Moore &amp; South OKC:</strong> The southern suburbs serve working families and young professionals who travel for both business and pleasure. Moore residents often need budget-friendly expedited service for family vacations to Mexico, mission trips to Central America, and spring break travel with children.
            </p>
            <p className="text-gray-600 text-base leading-[1.8]">
              <strong className="text-[#1A365D]">Yukon, Mustang &amp; Bethany:</strong> These western suburbs have growing populations with increasing international travel needs. Many residents commute to downtown OKC for work and need passport services that fit their schedules without requiring multiple office visits.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <div className="bg-[#1A365D] rounded-lg p-7 mb-8 text-white">
              <div className="flex items-center gap-3 mb-5">
                <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#F6C344] flex-shrink-0">
                  <i className="ri-passport-line text-[#1A365D] text-xl"></i>
                </div>
                <div>
                  <p className="font-bold text-base">Fast Passport Center — Oklahoma City Office</p>
                  <p className="text-white/60 text-xs mt-0.5">211 N Robinson Ave, Oklahoma City, OK 73102</p>
                </div>
              </div>
              <p className="text-white/70 text-sm mb-1">
                <i className="ri-map-pin-line text-[#F6C344] mr-1.5"></i>
                By appointment only — sign up on our website first to schedule
              </p>
              <p className="text-white/50 text-xs mb-3 ml-5">Walk-ins are not accepted. Schedule online then visit our downtown OKC office.</p>

              {/* Phone Number */}
              <div className="flex items-start gap-2.5 mb-3 ml-[52px]">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                  <i className="ri-phone-line text-[#F6C344] text-xs"></i>
                </div>
                <div>
                  <a href="tel:8772530084" className="text-white/80 text-sm hover:text-[#F6C344] transition-colors">(877) 253-0084</a>
                  <p className="text-white/40 text-xs">Nationwide toll-free — 24/7 voicemail</p>
                </div>
              </div>

              {/* Office Hours */}
              <div className="flex items-start gap-2.5 mb-3 ml-[52px]">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                  <i className="ri-time-line text-[#F6C344] text-xs"></i>
                </div>
                <div>
                  <div className="text-white/80 text-sm space-y-0.5">
                    <p className="whitespace-nowrap">Monday – Friday: 9:00 AM – 6:00 PM CST</p>
                    <p className="whitespace-nowrap">Saturday: 10:00 AM – 2:00 PM CST</p>
                    <p className="whitespace-nowrap">Sunday: Closed</p>
                  </div>
                </div>
              </div>

              {/* Appointment Note */}
              <div className="flex items-start gap-2.5 mb-4 ml-[52px]">
                <div className="w-6 h-6 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0 mt-0.5">
                  <i className="ri-calendar-check-line text-[#F6C344] text-xs"></i>
                </div>
                <div>
                  <p className="text-white/80 text-sm font-semibold">Appointment suggested</p>
                  <p className="text-white/50 text-xs mt-0.5 leading-relaxed">Appointment suggested to ensure your documents are reviewed before you arrive.</p>
                </div>
              </div>

              <p className="text-white/30 text-[10px] ml-[52px] mb-4 italic">Last updated: July 18, 2026</p>
              <div className="border-t border-white/10 pt-5">
                <p className="text-white/80 text-sm leading-relaxed mb-4">
                  After signing up online, schedule your appointment to visit our office at <strong className="text-white">211 N Robinson Ave in downtown Oklahoma City</strong>. Appointments are required — no walk-ins. Or choose <strong className="text-white">overnight shipping</strong> with our prepaid label from any UPS or FedEx location if you prefer not to visit in person.
                </p>
                <a
                  href="https://fastpassportcenter.com/checkout/"
                  className="inline-flex items-center gap-2 bg-[#F6C344] hover:bg-[#e5b430] text-[#1A365D] font-bold text-sm px-5 py-2.5 rounded-md transition-all whitespace-nowrap"
                >
                  Start My Passport <i className="ri-arrow-right-line"></i>
                </a>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {benefits.map((b, i) => (
                <div key={i} className="bg-[#F7F8FA] rounded-lg p-5 border border-gray-200">
                  <div className="w-9 h-9 flex items-center justify-center rounded-full bg-[#F6C344]/15 mb-3">
                    <i className={`${b.icon} text-[#1A365D] text-base`}></i>
                  </div>
                  <p className="font-bold text-[#1A365D] text-sm mb-1">{b.title}</p>
                  <p className="text-gray-500 text-xs leading-relaxed">{b.desc}</p>
                </div>
              ))}
            </div>
          </div>

          <div>
            <div className="bg-[#F7F8FA] rounded-lg p-7 mb-6 border border-gray-200">
              <h3 className="font-bold text-[#1A365D] text-sm uppercase tracking-wide mb-5">
                <i className="ri-map-pin-2-line text-[#F6C344] mr-2"></i>
                Communities We Serve
              </h3>
              <div className="space-y-1.5">
                {cities.map((city, i) => (
                  <div
                    key={i}
                    className="flex items-center justify-between py-2.5 px-3 bg-white rounded-md"
                  >
                    <div className="flex items-center gap-2.5">
                      <i className="ri-checkbox-circle-fill text-[#F6C344] text-sm"></i>
                      <span className="text-[#1A365D] font-medium text-sm">{city.name}</span>
                    </div>
                    {city.zips && (
                      <span className="text-gray-400 text-xs font-mono hidden sm:inline truncate ml-2 max-w-[160px]">{city.zips}</span>
                    )}
                  </div>
                ))}
              </div>
              <p className="text-gray-500 text-xs mt-4 leading-relaxed">
                Anywhere in Central Oklahoma — start online, ship overnight, and we handle the rest. No need to drive anywhere for regional agency appointments.
              </p>
              <div className="mt-4 pt-4 border-t border-gray-100">
                <p className="text-gray-400 text-xs font-semibold uppercase tracking-wider mb-3">Nearby Cities We Serve</p>
                <div className="flex flex-wrap gap-2">
                  {[
                    { name: "Tulsa", href: "/cities/tulsa" },
                    { name: "Norman", href: "/cities/norman" },
                    { name: "Edmond", href: "/cities/edmond" },
                    { name: "Broken Arrow", href: "/cities/broken-arrow" },
                    { name: "Stillwater", href: "/states/oklahoma" },
                    { name: "Lawton", href: "/states/oklahoma" },
                  ].map((link) => (
                    <a
                      key={link.href + link.name}
                      href={link.href}
                      className="inline-flex items-center gap-1 text-xs text-[#1A365D] hover:text-[#F6C344] font-medium transition-colors bg-white border border-gray-200 hover:border-[#F6C344] rounded-full px-3 py-1.5 whitespace-nowrap"
                    >
                      {link.name} <i className="ri-arrow-right-line text-[10px]"></i>
                    </a>
                  ))}
                </div>
              </div>
            </div>

            <div className="bg-[#1A365D] rounded-lg p-5">
              <p className="text-white/50 text-xs uppercase tracking-widest font-semibold mb-4">Why Oklahoma City Travelers Choose Fast Passport Center</p>
              <div className="grid grid-cols-2 gap-3">
                {[
                  { icon: "ri-government-line", value: "Registered Courier", label: "U.S. Department of State" },
                  { icon: "ri-award-line", value: "A+ Rating", label: "Better Business Bureau" },
                  { icon: "ri-calendar-check-line", value: "20+ Years", label: "Serving Travelers Nationwide" },
                  { icon: "ri-customer-service-2-line", value: "Real Humans", label: "Live Support — Not a Bot" },
                ].map((item, i) => (
                  <a
                    key={i}
                    href="https://fastpassportcenter.com"
                    className="flex items-center gap-2.5 bg-white/5 hover:bg-white/10 rounded-md px-3 py-2.5 transition-colors cursor-pointer"
                  >
                    <div className="w-8 h-8 flex items-center justify-center rounded-full bg-[#F6C344]/15 flex-shrink-0">
                      <i className={`${item.icon} text-sm text-[#F6C344]`}></i>
                    </div>
                    <div className="text-left">
                      <span className="text-white text-xs font-bold block leading-tight">{item.value}</span>
                      <span className="text-white/50 text-xs leading-tight block">{item.label}</span>
                    </div>
                  </a>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}